import React from 'react';
import { Tours, PropertyDetailsToursProps } from '@greystar/ui';
import { GetStaticComponentProps } from '@sitecore-jss/sitecore-jss-nextjs';
import { Property } from '@greystar/lib';

const ToursSection = (props: PropertyDetailsToursProps) => {
  return (
    <Tours
      tours={props.tours}
      propertyName={props.propertyName}
      propertyState={props.propertyState}
      propertyLocation={props.propertyLocation}
      propertyId={props.propertyId}
    />
  );
};

export const getStaticProps: GetStaticComponentProps = async (
  rendering,
  layoutData
): Promise<PropertyDetailsToursProps> => {
  const props = rendering as unknown as PropertyDetailsToursProps;
  const property = layoutData.sitecore.context.property as Property;

  if (!property) {
    return { ...props };
  }

  return {
    ...props,
    tours: property.tours ?? null,
    propertyName: property.name ?? null,
    propertyState: property.location?.state ?? null,
    propertyLocation: property.location?.address ?? null,
    propertyId: property.id ?? null,
  };
};

export default ToursSection;
